import * as React from 'react';

// tslint:disable:max-line-length

export const compassIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <defs>
      <path
        id="a"
        d="M8.5 0l3.35 8.615a1 1 0 0 1-.016.763L8.5 17 5.166 9.378a1 1 0 0 1-.016-.763L8.5 0zm0 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
      />
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(1 2)">
      <circle cx="8.5" cy="8.5" r="7.5" stroke="currentColor" strokeWidth="1.5" />
      <g transform="rotate(45 8.5 8.5)">
        <use fill="currentColor" xlinkHref="#a" />
        <path
          stroke="#FFF"
          strokeWidth="2"
          d="M8.5-2.759l4.282 11.012a2 2 0 0 1-.031 1.526L8.5 19.495 4.25 9.779a2 2 0 0 1-.032-1.526L8.5-2.76zM8.5 9a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"
        />
      </g>
    </g>
  </svg>
);

export const pinIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.171 7.985l4.524 7.819c.15.259.39.264.544 0l4.524-7.819.066-.13a5.265 5.265 0 0 0 .671-2.452c0-2.238-1.405-4.245-3.533-5.045a5.567 5.567 0 0 0-6.06 1.436 5.328 5.328 0 0 0-.802 6.072l.066.12zM6 3.025c1 0 1.902.595 2.28 1.505a2.39 2.39 0 0 1-.554 2.643 2.497 2.497 0 0 1-2.7.496 2.419 2.419 0 0 1-1.49-2.266C3.56 4.083 4.656 3.025 6 3.026z"
    />
  </svg>
);
